angular.module('rjmNg.services').factory 'dateService', [
  "$rootScope"
  "namedDates"
  "timeRangeEnums"
  ($rootScope, namedDates, timeRangeEnums) ->

    MOVING_TIME_RANGE_TYPES = timeRangeEnums.MOVING_TIME_RANGE_TYPES
    TIME_INTERVAL_VALUES = timeRangeEnums.TIME_INTERVAL_VALUES
    TIME_RANGE_TYPES = timeRangeEnums.TIME_RANGE_TYPES
    RANGE_TYPES = timeRangeEnums.RANGE_TYPES
    TIME_RANGE_VALUES = timeRangeEnums.TIME_RANGE_VALUES
    MOVING_TIME_RANGE_DIRECTIONS = timeRangeEnums.MOVING_TIME_RANGE_DIRECTIONS

    dateService = {}

    dateService.timeVersion = (version) ->
      if version is 0.1 then "time" else ":time"

    # Consolidated date formatting into one function
    # date = date string
    # intervalName = interval name string
    # force = boolean.
    #   True always returns a date or 'Invalid date'.
    #   False returns original date string when not a valid date
    dateService.format = (date, intervalName, force=true) ->
      isDateANumber = not isNaN(+date)
      if isDateANumber and force
        return "#{intervalName} #{date}"
      if not force and (moment(date).format() is namedDates.INVALID_DATE or isDateANumber)
        return date
      switch (intervalName)
        when 'Hour' then return @_hourFormat(date)
        when 'Hour-Zone' then return @_hourZoneFormat(date)
        when 'Day'
          switch date
            when namedDates.OLDEST then return date # Used in static date ranges
            when namedDates.NOW then return date # used in static date ranges
            else return moment(date).format('dddd, MMMM Do, YYYY')
        when 'Week' then return 'Week of ' + moment(date).format("MMMM Do, YYYY")
        when 'Month' then return moment(date).format('MMMM YYYY')
        when 'Quarter' then return 'Q'+ moment(date).format('Q YYYY')
        when 'Year' then return moment(date).format('YYYY')
        else return moment(date).format('YYYY-MM-DD')

    dateService._hourZoneFormat = (date) ->
      # Moment dropped support for displaying the time zone, so we
      # we need to get this with javascript
      localTimeZone = new Date().toTimeString().slice(-5)
      return @_hourFormat(date) + " #{localTimeZone}"

    dateService._hourFormat = (date) ->
      return moment(date).format('hh:mm A, MMMM Do, YYYY')

    # Returns a shortended date format
    # date = date string
    # intervalName = interval name string
    # force = boolean.
    #   True always returns a date or 'Invalid date'.
    #   False returns original date string when not a valid date
    dateService.shortFormat = (date, intervalName, force=true) ->
      isDateANumber = not isNaN(+date)
      if isDateANumber and force
        return "#{intervalName} #{date}"
      if not force and (moment(date).format() is namedDates.INVALID_DATE or isDateANumber)
        return date
      switch (intervalName)
        when 'Hour' then return moment(date).format('hh:mm A, MMM Do, YYYY')
        when 'Day', 'Week'
          switch date
            when namedDates.OLDEST then return date # Used in static date ranges
            when namedDates.NOW then return date # used in static date ranges
            else return moment(date).format('MMM Do, YYYY')
        when 'Month' then return moment(date).format('MMM YYYY')
        when 'Quarter' then return 'Q'+ moment(date).format('Q YYYY')
        when 'Year' then return moment(date).format('YYYY')
        else return moment(date).format('YYYY-MM-DD')

    # identifies what type of figure timerange object this is
    dateService.identifyTimeRange = (timeRange) ->
      unless timeRange.start? and timeRange.end?
        timeRangeType = MOVING_TIME_RANGE_TYPES.ALL_TIME
      else if timeRange.start is TIME_RANGE_VALUES.START and timeRange.end is TIME_RANGE_VALUES.END
        timeRangeType = MOVING_TIME_RANGE_TYPES.ALL_TIME
      else if timeRange.start.type is RANGE_TYPES.STATIC or timeRange.end.type is RANGE_TYPES.STATIC
        timeRangeType = TIME_RANGE_TYPES.STATIC
      else if timeRange.start.type is RANGE_TYPES.MOVING or timeRange.end.type is RANGE_TYPES.MOVING
        timeRangeType = TIME_RANGE_TYPES.MOVING

      return timeRangeType

    # Consolidated meanings for date range selections
    # Accepts the following input
    #   type: string (e.g 'All-time', 'Last 7 Days', 'Last Quarter')
    #   start: dateString (e.g. '2013-01-22'), or string (e.g. 'Oldest Available Date')
    #   endDate:  dateString (e.g. '2013-10-26'), or string (e.g. 'Now')
    #
    # Returns a time range
    dateService.getStaticTimeRange = (startDate, endDate, version=0.1) ->
      timerange =
        field: @timeVersion(version)
        start:
          type: undefined
        end:
          type: undefined

      # If we get a range from oldest to now, just switch to all time
      if endDate is namedDates.NOW or endDate is undefined
        timerange.end = TIME_RANGE_VALUES.END
      else
        timerange.end =
          type: RANGE_TYPES.STATIC
          datetime: endDate

      if startDate is namedDates.OLDEST or startDate is undefined
        timerange.start = TIME_RANGE_VALUES.START
      else
        timerange.start =
          type: RANGE_TYPES.STATIC
          datetime: startDate

      return timerange

    dateService.isStaticRangeAllTime = (timerange) ->
      if timerange?
        return (timerange.start.datetime is namedDates.OLDEST or
                timerange.start is TIME_RANGE_VALUES.START) and
               (timerange.end.datetime is namedDates.NOW or
                timerange.end is TIME_RANGE_VALUES.END)
      else
        return false

    dateService.getTypeFromMovingTimeRange = (timerange) ->
      type = null

      if @isRangeMoving(timerange)
        startVal = timerange.start.value * -1
        endVal = timerange.end.value * -1
        startUnit = timerange.start.unit
        endUnit = timerange.end.unit
        if (startVal is -1 and endVal is 0 and startUnit is TIME_INTERVAL_VALUES.DAY and endUnit is TIME_INTERVAL_VALUES.DAY)
          type = MOVING_TIME_RANGE_TYPES.TODAY
        else if (startVal is -2 and endVal is -1 and startUnit is TIME_INTERVAL_VALUES.DAY and endUnit is TIME_INTERVAL_VALUES.DAY)
          type = MOVING_TIME_RANGE_TYPES.YESTERDAY
        else if (startVal is -2 and endVal is -1 and startUnit is TIME_INTERVAL_VALUES.WEEK and endUnit is TIME_INTERVAL_VALUES.WEEK)
          type = MOVING_TIME_RANGE_TYPES.LAST_WEEK
        else if (startVal is -2 and endVal is -1 and startUnit is TIME_INTERVAL_VALUES.MONTH and endUnit is TIME_INTERVAL_VALUES.MONTH)
          type = MOVING_TIME_RANGE_TYPES.LAST_MONTH
        else if (startVal is -2 and endVal is -1 and startUnit is TIME_INTERVAL_VALUES.QUARTER and endUnit is TIME_INTERVAL_VALUES.QUARTER)
          type = MOVING_TIME_RANGE_TYPES.LAST_QUARTER
        else if (startVal is -2 and endVal is -1 and startUnit is TIME_INTERVAL_VALUES.YEAR and endUnit is TIME_INTERVAL_VALUES.YEAR)
          type = MOVING_TIME_RANGE_TYPES.LAST_YEAR
        else if (startVal is -1 and endVal is 0 and startUnit is TIME_INTERVAL_VALUES.WEEK and endUnit is TIME_INTERVAL_VALUES.WEEK)
          type = MOVING_TIME_RANGE_TYPES.THIS_WEEK
        else if (startVal is -1 and endVal is 0 and startUnit is TIME_INTERVAL_VALUES.MONTH and endUnit is TIME_INTERVAL_VALUES.MONTH)
          type = MOVING_TIME_RANGE_TYPES.THIS_MONTH
        else if (startVal is -1 and endVal is 0 and startUnit is TIME_INTERVAL_VALUES.QUARTER and endUnit is TIME_INTERVAL_VALUES.QUARTER)
          type = MOVING_TIME_RANGE_TYPES.THIS_QUARTER
        else if (startVal is -1 and endVal is 0 and startUnit is TIME_INTERVAL_VALUES.YEAR and endUnit is TIME_INTERVAL_VALUES.YEAR)
          type = MOVING_TIME_RANGE_TYPES.THIS_YEAR
        else
          type = MOVING_TIME_RANGE_TYPES.CUSTOM
      else if @isRangeStatic(timerange) and @isStaticRangeAllTime(timerange)
        type = MOVING_TIME_RANGE_TYPES.ALL_TIME

      return type


    dateService.getMovingTimeRangeFromType = (type, version=0.1) ->
      timerange =
        field: @timeVersion(version)
        start:
          type: undefined
        end:
          type: undefined

      switch type

        when MOVING_TIME_RANGE_TYPES.ALL_TIME
          timerange.start = TIME_RANGE_VALUES.START
          timerange.end = TIME_RANGE_VALUES.END

        when MOVING_TIME_RANGE_TYPES.TODAY
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.DAY
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: 0
            unit: TIME_INTERVAL_VALUES.DAY

        when MOVING_TIME_RANGE_TYPES.YESTERDAY
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -2
            unit: TIME_INTERVAL_VALUES.DAY
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.DAY

        when MOVING_TIME_RANGE_TYPES.LAST_7_DAYS
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -8
            unit: TIME_INTERVAL_VALUES.DAY
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.DAY

        when MOVING_TIME_RANGE_TYPES.LAST_14_DAYS
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -15
            unit: TIME_INTERVAL_VALUES.DAY
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.DAY

        when MOVING_TIME_RANGE_TYPES.LAST_30_DAYS
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -31
            unit: TIME_INTERVAL_VALUES.DAY
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.DAY

        when MOVING_TIME_RANGE_TYPES.LAST_90_DAYS
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -91
            unit: TIME_INTERVAL_VALUES.DAY
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.DAY

        when MOVING_TIME_RANGE_TYPES.LAST_365_DAYS
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -366
            unit: TIME_INTERVAL_VALUES.DAY
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.DAY

        when MOVING_TIME_RANGE_TYPES.LAST_WEEK
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -2
            unit: TIME_INTERVAL_VALUES.WEEK
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.WEEK

        when MOVING_TIME_RANGE_TYPES.LAST_2_WEEKS
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -3
            unit: TIME_INTERVAL_VALUES.WEEK
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.WEEK

        when MOVING_TIME_RANGE_TYPES.LAST_MONTH
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -2
            unit: TIME_INTERVAL_VALUES.MONTH
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.MONTH

        when MOVING_TIME_RANGE_TYPES.LAST_24_MONTHS
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -24
            unit: TIME_INTERVAL_VALUES.MONTH
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: 0
            unit: TIME_INTERVAL_VALUES.MONTH

        when MOVING_TIME_RANGE_TYPES.LAST_YEAR
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -2
            unit: TIME_INTERVAL_VALUES.YEAR
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.YEAR

        when MOVING_TIME_RANGE_TYPES.LAST_QUARTER
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -2
            unit: TIME_INTERVAL_VALUES.QUARTER
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.QUARTER

        when MOVING_TIME_RANGE_TYPES.THIS_WEEK
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.WEEK
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: 0
            unit: TIME_INTERVAL_VALUES.WEEK

        when MOVING_TIME_RANGE_TYPES.THIS_MONTH
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.MONTH
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: 0
            unit: TIME_INTERVAL_VALUES.MONTH

        when MOVING_TIME_RANGE_TYPES.THIS_YEAR
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.YEAR
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: 0
            unit: TIME_INTERVAL_VALUES.YEAR

        when MOVING_TIME_RANGE_TYPES.THIS_QUARTER
          timerange.start =
            type: RANGE_TYPES.MOVING
            value: -1
            unit: TIME_INTERVAL_VALUES.QUARTER
          timerange.end =
            type: RANGE_TYPES.MOVING
            value: 0
            unit: TIME_INTERVAL_VALUES.QUARTER

      return timerange

    # Returns the largest time interval appropriate for a time period
    dateService.getLargestTimeInterval = (startDate, endDate) ->

      # Calculate the number of seconds between each date
      duration = moment(endDate).format("X") - moment(startDate).format("X")

      # Find the largest appropriate time interval for this duration
      # Not using Quarters here, because I think it's more common to use Months
      largestInterval = switch
        when duration > moment.duration(1, 'Year').asSeconds() then TIME_INTERVAL_VALUES.YEAR
        when duration > moment.duration(2, 'Months').asSeconds() then TIME_INTERVAL_VALUES.MONTH
        when duration > moment.duration(4, 'Weeks').asSeconds() then TIME_INTERVAL_VALUES.WEEK
        else TIME_INTERVAL_VALUES.DAY

      return largestInterval

    # If we changed our time period, we may have made it too small for the time period
    # If that is the case, return the largest one that is still appropriate
    dateService.getAppropriateTimeInterval = (startDate, endDate, currentTimeInterval) ->

      # First get the largest appropriate time interval
      largestTimeInterval = @getLargestTimeInterval(startDate, endDate)

      largestDuration = moment.duration(1, largestTimeInterval)
      currentDuration = moment.duration(1, currentTimeInterval)

      # Durations can't handle quarters yet
      if currentTimeInterval is TIME_INTERVAL_VALUES.QUARTER
        currentDuration = moment.duration(3, 'Months')

      # If our current interval exceeds one unit of the largest one, change it
      if currentDuration > largestDuration
        currentTimeInterval = largestTimeInterval

      return currentTimeInterval

    # Returns whether the start of the specified range corresponds to the oldest possible date
    dateService.startIsOldest = (timerange) ->
      return not timerange?.start? or timerange.start is TIME_RANGE_VALUES.START or timerange?.start?.datetime is namedDates.OLDEST

    # Returns whether the end of the specified range corresponds to now
    dateService.endIsNow = (timerange) ->
      return not timerange?.end? or timerange.end is TIME_RANGE_VALUES.END or timerange?.end?.datetime is namedDates.NOW

    # Translates an RJQL range to one usuable by our timeRangeDirective
    dateService.translateToLocalRange = (timerange, version=0.1) ->
      startIsOldest = @startIsOldest(timerange)
      endIsNow = @endIsNow(timerange)

      if (timerange?.start?.type is RANGE_TYPES.STATIC or startIsOldest) and (timerange?.end?.type is RANGE_TYPES.STATIC or endIsNow)
        field: if timerange?.field? then timerange.field else @timeVersion(version)
        type: TIME_RANGE_TYPES.STATIC
        start:
          datetime: if startIsOldest then namedDates.OLDEST else timerange.start.datetime
          type: RANGE_TYPES.STATIC
        end:
          datetime: if endIsNow then namedDates.NOW else timerange.end.datetime
          type: RANGE_TYPES.STATIC
      else if timerange.start?.type is RANGE_TYPES.MOVING and timerange.end?.type is RANGE_TYPES.MOVING
        field: if timerange?.field? then timerange.field else @timeVersion(version)
        type: TIME_RANGE_TYPES.MOVING
        start:
          direction: if timerange.start.value <= 0 then MOVING_TIME_RANGE_DIRECTIONS.PAST else MOVING_TIME_RANGE_DIRECTIONS.FUTURE
          unit: timerange.start.unit
          value: Math.abs(timerange.start.value)
          type: RANGE_TYPES.MOVING
        end:
          direction: if timerange.end.value <= 0 then MOVING_TIME_RANGE_DIRECTIONS.PAST else MOVING_TIME_RANGE_DIRECTIONS.FUTURE
          unit: timerange.end.unit
          value: Math.abs(timerange.end.value)
          type: RANGE_TYPES.MOVING
      else
        return null

    # Translates the range used by our timeRangeDirective to an RJQL range
    dateService.translateToRJQLRange = (localTimeRange, version=0.1) ->
      if localTimeRange.type is TIME_RANGE_TYPES.STATIC
        timerange =
          field: @timeVersion(version)

        if localTimeRange.start.datetime is namedDates.OLDEST
          timerange.start = TIME_RANGE_VALUES.START
        else
          timerange.start =
            datetime: localTimeRange.start.datetime
            type: RANGE_TYPES.STATIC

        if localTimeRange.end.datetime is namedDates.NOW
          timerange.end = TIME_RANGE_VALUES.END
        else
          timerange.end =
            datetime: localTimeRange.end.datetime
            type: RANGE_TYPES.STATIC

        return timerange
      else if localTimeRange.type is TIME_RANGE_TYPES.MOVING
        field: @timeVersion(version)
        start:
          type: RANGE_TYPES.MOVING
          unit: localTimeRange.start.unit
          value: if localTimeRange.start.direction is MOVING_TIME_RANGE_DIRECTIONS.PAST then -1 * localTimeRange.start.value else localTimeRange.start.value
        end:
          type: RANGE_TYPES.MOVING
          unit: localTimeRange.end.unit
          value: if localTimeRange.end.direction is MOVING_TIME_RANGE_DIRECTIONS.PAST then -1 * localTimeRange.end.value else localTimeRange.end.value
      else
        return null

    # Returns whether a range and a local range are equivalent
    dateService.compareRangeToLocalRange = (timerange, localTimeRange, version=0.1) ->
      # Compare using local ranges, since there are no abiguous representations
      translatedRange = @translateToLocalRange(timerange, version)
      return timerange? and localTimeRange? and angular.equals(localTimeRange, translatedRange)

    # Converts Moving time range to range with dates (using Moment.js)
    dateService.movingTimeRangeToDatetime = (localTimeRange) ->
      startOfUnit = moment().startOf(localTimeRange.start.unit)

      endDate = moment().add(+localTimeRange.end.value, localTimeRange.end.unit)
      if localTimeRange.end.value > 0 then endDate = endDate.subtract(1, localTimeRange.end.unit)

      if +localTimeRange.end.value isnt 0
        endDate = endDate.endOf(localTimeRange.end.unit)

      start = startOfUnit.subtract(Math.abs(localTimeRange.start.value) - 1, localTimeRange.start.unit)
      end = endDate

      formattedRange =
        start: start
        end: end

    # Convert an RJQL range to one suitable for displaying
    # Optional parameter 'format' is a Moment.js datetime formatting string
    dateService.getDisplayRange = (timerange, format = 'MMM Do, YYYY') ->
      unless timerange?.start? and timerange?.end? then return

      localTimeRange = angular.copy(timerange)

      if @isRangeStatic(localTimeRange)
          formattedRange =
            start: if localTimeRange.start is TIME_RANGE_VALUES.START or localTimeRange.start.datetime is namedDates.OLDEST then namedDates.OLDEST else moment(localTimeRange.start.datetime).format(format)
            end: if localTimeRange.end is TIME_RANGE_VALUES.END or localTimeRange.end.datetime is namedDates.NOW then namedDates.NOW else moment(localTimeRange.end.datetime).endOf('day').format(format)
      else # Moving time range
        unformattedRange = @movingTimeRangeToDatetime(localTimeRange)

        if format.toLowerCase().indexOf('h') is -1 and (localTimeRange.start.unit is TIME_INTERVAL_VALUES.HOUR or localTimeRange.end.unit is TIME_INTERVAL_VALUES.HOUR) then format += ', h:mm a'

        formattedRange =
          start: unformattedRange.start.format(format)
          end: unformattedRange.end.format(format)

      return formattedRange

    dateService.isRangeStatic = (timerange) ->
      if timerange?
        return (timerange.type is TIME_RANGE_TYPES.STATIC or
          timerange.start?.type?.toLowerCase() is RANGE_TYPES.STATIC or
          timerange.end?.type?.toLowerCase() is RANGE_TYPES.STATIC) or
          timerange.start is TIME_RANGE_VALUES.START or
          timerange.end is TIME_RANGE_VALUES.END or
          timerange.start?.datetime is namedDates.OLDEST or
          timerange.end?.datetime is namedDates.NOW
      else
        return false

    dateService.isRangeMoving = (timerange) ->
      if timerange?
        return timerange.type is TIME_RANGE_TYPES.MOVING or
          timerange.start?.type?.toLowerCase() is RANGE_TYPES.MOVING or
          timerange.end?.type?.toLowerCase() is RANGE_TYPES.MOVING
      else
        return false

    # Returns a string representation of a time range
    dateService.getRangeString = (timerange, format = 'MMM Do, YYYY', returnArray = false) ->
      return (if returnArray then ["", ""] else "") unless timerange?

      startIsOldest = @startIsOldest(timerange)
      endIsNow = @endIsNow(timerange)

      if startIsOldest and endIsNow
        return if returnArray then ["#{namedDates.OLDEST}", "#{namedDates.NOW}"] else MOVING_TIME_RANGE_TYPES.ALL_TIME
      else
        displayRange = @getDisplayRange(timerange, format)

        startString = if displayRange?.start? then displayRange.start else timerange.start.datetime

        if timerange.end.value is 0
          endString = namedDates.NOW
        else
          endString = if displayRange?.end? then displayRange.end else timerange.end.datetime

        return if returnArray then ["#{startString}", "#{endString}"] else "#{startString} - #{endString}"

    # Returns whether a static range is valid (namely, that the end date doesn't
    # occur before the start date.)
    dateService.staticLocalRangeIsValid = (localTimeRange) ->
      return true unless @isRangeStatic(localTimeRange)

      return localTimeRange.start?.datetime? and localTimeRange.end?.datetime? and
        localTimeRange.start.datetime isnt namedDates.NOW and # The range can't start now, since there is no valid date which occurs after now
        localTimeRange.end.datetime isnt namedDates.OLDEST and # The range can't end at the oldest date, since there is no valid date which occurs after oldest
        (localTimeRange.start.datetime is namedDates.OLDEST or
        localTimeRange.end.datetime is namedDates.NOW or
        moment(localTimeRange.end.datetime).isSame(localTimeRange.start.datetime) or
        moment(localTimeRange.end.datetime).isAfter(localTimeRange.start.datetime))

    dateService.movingRangeIsValid = (timerange) ->
      return true unless @isRangeMoving(timerange)

      datetimeRange = @movingTimeRangeToDatetime(timerange)
      return moment(datetimeRange.end).isAfter(datetimeRange.start)

    dateService
  ]
